import React, { useState } from "react";
import {
  Accordions,
  Accordionsitems,
  AccordionsContent,
  AccordionsContentinner,
  AccordionsTitle,
  AccordionHeader,
} from "./style";
import { ListState, ListItemState } from "../stateTemplate";
import { graphql, useStaticQuery } from "gatsby";

const StateManufacturerAccordion = () => {
  const [expandedPanel, setExpandedPanel] = useState("");

  const {
    allContentfulStatePages: { edges: stateList },
  } = useStaticQuery(
    graphql`
      query {
        allContentfulStatePages {
          edges {
            node {
              stateName
            }
          }
        }
      }
    `
  );

  return (
    <Accordions className="accordions">
      <Accordionsitems className="accordions-items">
        <AccordionHeader>
          <AccordionsTitle
            className={expandedPanel === "areas" ? "active" : ""}
            onClick={() => {
              setExpandedPanel(expandedPanel === "areas" ? "" : "areas");
            }}
          >
            <strong>Areas We Serve</strong>
            <span></span>
          </AccordionsTitle>
          {/* <AccordionsTitle
            className={expandedPanel === "manufacturers" ? "active" : ""}
            onClick={() => {
              setExpandedPanel(
                expandedPanel === "manufacturers" ? "" : "manufacturers"
              );
            }}
          >
            <strong>Our Manufacturers</strong>
            <span></span>
          </AccordionsTitle> */}
        </AccordionHeader>
        <AccordionsContent
          className={
            expandedPanel === "areas"
              ? "expanded-accordion"
              : "closed-accordion"
          }
        >
          <AccordionsContentinner>
            <ListState>
              {stateList.map((item, index) => (
                <ListItemState
                  key={index}
                  to={`/${item.node.stateName
                    .split(" ")
                    .join("-")
                    .toLowerCase()}`}
                >
                  {item.node.stateName}
                </ListItemState>
              ))}
            </ListState>
          </AccordionsContentinner>
        </AccordionsContent>

        {/* <AccordionsContent
          className={
            expandedPanel === "manufacturers"
              ? "expanded-accordion"
              : "closed-accordion"
          }
        >
          <AccordionsContentinner>
            <ListManufacturer>
              {manufacturerList.map((item, index) => (
                <ListItemManufacturer key={index} to={item.node.url}>
                  {item.node.pageTitle}
                </ListItemManufacturer>
              ))}
            </ListManufacturer>
          </AccordionsContentinner>
        </AccordionsContent> */}
      </Accordionsitems>
    </Accordions>
  );
};

export default StateManufacturerAccordion;
